module.exports = __webpack_public_path__ + "static/media/lancome-hypnose-big.ea4bd2e6.png";